<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
      <span>></span>
      小题列表
      <span>></span>
      编辑填空题
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>
            <div class="xiaoqu_2">
            </div>
          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 功能前方标注红色星号的属于必填内容，未标星号的是选填内容可进行自由填写，不同功能的备注事宜写在功能后方
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
              <el-form-item label="习题范例" prop="desc" v-show="show">
                <div class="xtfl1">
                  <h3>句型转换： The exam is very important to us.</h3>

                  <div class="example">
                    <span>(转为感叹句)：<span style="color:#00A6E6;">_①_ _②_</span>important exam it is to us!</span>
                  </div>
                  <el-button @click="show=false" v-show="show" type="primary">收起</el-button>
                </div>
              </el-form-item>

              <el-form-item label="小题题目" prop="title">
                <el-input id="insertAnswer" type="textarea" v-model="form.title" @blur="handleInputBlur" class="xtfl" rows="9" placeholder="请在此处输入填空题题型的题干，并点击“插入答案”按钮进行答案处的标注，并在习题答案处填入正确答案"></el-input>
                <div class="expansion">
                  <el-button @click="show=true" v-show="!show" type="primary">展开</el-button>
                </div>
                <div class="update">
                  <el-button v-if="audiosrc" @click="removeaudio" type="primary" style="width:110px;height:35px; margin:3px 20px 0  0;">删除音频</el-button>
                  <el-upload v-else class="upload-demo" style="marginRight:20px;" action="#" :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary">+ 上传音频</el-button>
                  </el-upload>
                   <audio v-if="audiosrc" controls controlsList="nodownload" style="position:absolute; top:80px; width:140px; height:40px;" :src="audiosrc"></audio>
                      <div style="position:absolute; top:80px; left:165px; width:100px; height:100px;" v-if="imageUrl">
                       <img :src="imageUrl" alt="" style="width:100%;">
                      </div>
                      <el-button v-if="imageUrl" @click="removeimage" type="primary" style="width:110px;height:35px;">删除图片</el-button>
                  <el-upload v-else action="#" :show-file-list="false" :http-request="handleAvatarSuccessImg">
                    <el-button size="small" type="primary">+ 上传图片</el-button>
                  </el-upload>
                </div>
                <div class="insert_answer">
                  <el-button size="small" type="primary" round @click="insertAnswer()">插入答案</el-button>
                </div>

              </el-form-item>
              <el-form-item label="小题答案" prop="answerStr">
                <el-input type="textarea" class="xtfl" v-model="form.answerStr" rows="9" placeholder="将正确单词或答案填入此处，并用“;”分号进行单词或答案之间的分割，如：What ; is ，若此处答案不唯一可用/号隔开相应答案"></el-input>
              </el-form-item>
              <el-form-item label="答案解析" prop="lookpicture">
                <el-input type="textarea" v-model="answerparse" class="xtfl" rows="9" placeholder="您可自由输入该习题的答案解析"></el-input>

              </el-form-item>

              <el-form-item label="难易程度" prop="radios">
                <el-radio-group v-model="form.radios">
                  <el-radio :label="1">易</el-radio>
                  <el-radio :label="2">中</el-radio>
                  <el-radio :label="3">难</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="知识点" prop="knowledge">
                <el-input type="textarea" v-model="form.points" class="xtfl" rows="9" placeholder="您可自行输入该题目所涉及到的知识点，可自由选择是否输入"></el-input>
              </el-form-item>
              <el-form-item class="tijiao">
                <el-button type="primary" @click="updatechoice()" v-if="edit" style="width:240px; height:46px;">继续制题</el-button>
                <el-button type="primary" @click="editUpdate()" v-else style="width:240px; height:46px;">保存编辑</el-button>
                <el-button style="width:240px; height:46px; marginLeft:30px;" v-show="edit" @click="comeBack=true">保存并返回</el-button>
                <div style="marginLeft:240px;" v-show="comeBack">
                  <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBackBig(1)">返回大题列表</el-button>
                  <div>
                      <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBacksmall(2)">返回小题列表</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>

        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
const axios = require('axios');
export default {
  data() {
    return {
      form: {
        title: '',
        content: '',
        points:'',
        answerStr:'',
        radios:'',
      },
      FormRules: {
        title: [
          { required: true, message: '请您填写必填信息',trigger: 'blur'}
        ],
        answerStr: [
          { required: true, message: '请您填写必填信息',trigger: 'blur'}
        ],
        radios: [
          { required: true, message: '请您填写必填信息',trigger: 'change'}
        ],
      },
      edit:true,
      show:true,
      insertList:['_①_','_②_','_③_','_④_','_⑤_','_⑥_','_⑦_','_⑧_','_⑨_','_⑩_','_⑪_','_⑫_','_⑬_','_⑭_','_⑮_','_⑯_','_⑰_','_⑱_','_⑲_','_⑳_'],
      textContent: '',
      answerparse:'',
      labelName: '',
      imageUrl:'',
      audiosrc:'',
      answer:'',
      index:0,
      comeBack:false,
    };
  },
  created() {
    this.verdict();
  },

  methods: {
    verdict(){
      console.log(this.$route.query.questionId);
      if(this.$route.query.questionId === undefined){
        console.log(111);
      }else{
        this.findquestion();
        this.edit = false;
      }
    },
     handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart;
    },
    //删除音频
    removeaudio(){
      this.audiosrc = '';
      this.$message.success('删除成功!');
    },
    //删除图片
    removeimage(){
      this.imageUrl = '';
      this.$message.success('删除成功!');
    },
    // 上传音频
    handleAvatarSuccess(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audio', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if(result.data.code===0) {
            this.audiosrc = result.data.data;
            return this.$message.success('上传成功!');
          }
          
        })
        .catch((err) => {
          this.$message.error('上传音频错误：' + err);
        });
    },
    //插入答案
    insertAnswer(){
       var elInput = document.getElementById('insertAnswer');
       var startPos = elInput.selectionStart;
       var endPos = elInput.selectionEnd;
       if (startPos === undefined || endPos === undefined) return
       var txt = elInput.value;
       var result = txt.substring(0, startPos) + this.insertList[this.index] + txt.substring(endPos)
       elInput.value = result;
       elInput.focus();
       elInput.selectionStart = startPos + this.insertList[this.index].length;
       elInput.selectionEnd = startPos + this.insertList[this.index].length;
      this.form.title = result;
        this.index++;
        if(this.index>20) {
          return this.$message.success('超出最大限制!')
        }
    },
    beforeAvatarUpload(file) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },
    //返回大题列表
    comeBackBig(big) {
      this.updatechoice(big);
    },
    comeBacksmall(big) {
      this.updatechoice(big);
    },
    //上传图片
   handleAvatarSuccessImg(data) {
      console.log(data.file);
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.imageUrl = result.data.data;
            return this.$message.success('上传成功！');
          } 
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
      //查询题目
    findquestion(){
       let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/'+this.$route.query.questionId+'/completion',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res,'aaa');
          if (res.data.code === 0) {
            let data = res.data.data;
            this.form.title = data.text;
            this.imageUrl = data.img;
            this.suggestedAnswers = data.answerOpt;
            this.form.radios = data.level;
            this.form.answerStr = data.answerStr;
            this.answerparse = data.parse;
            this.form.points = data.points; 
          }
        })
    },
    //编辑提交
    editUpdate(){
       let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/'+this.$route.query.id+'/'+this.$route.query.questionId+'/completion/upd',
        method: 'POST',
        data: {
           img: this.imageUrl,
          level: this.form.radios,
          answerStr:this.form.answerStr,
          parse: this.answerparse,
          points: this.form.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success('编辑成功！');
          this.$router.go(-1);
        }
        else {
          this.$message.warning(res.data.message);
        }
      });
    },
    //提交选择题
    updatechoice(big) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/make/completion',
        method: 'POST',
        data: {
          attached: {
            bookId: Number(this.$route.query.bookid),
            section: this.$route.query.littleNode,
          },
          audio: this.audiosrc,
          img: this.imageUrl,
          level: this.form.radios,
          pack: {
            number: this.$route.query.number,
            questionPackId: this.$route.query.id,
            score: 0,
          },
          answerStr:this.form.answerStr,
          parse: this.answerparse,
          points: this.form.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          if(big === 1) {
            this.$router.go(-2);
          } else if (big===2) {
            this.$router.go(-1);
          }
          this.$message.success('提交成功！');
          this.index = 0;
          this.imageUrl = '';
          this.audiosrc = '';
          this.form.title ='';
          this.form.answerStr = '';
          this.form.radios = '';
          this.answerparse = '';
          this.form.points = '';
        }
         else{
          this.$message.error(res.data.message);
        }
      }).catch((err) => {
         if(big ==1||big==2){
             this.$confirm('必填信息出错，退出信息将被清空，确定退出?', '退出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            console.log(111);
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
          });
          }else {
            this.$message.error('制题失败:'+err)
          }
        });
    },
  },
};
</script>
<style lang="less">
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.xtfl {
  width: 750px /* 750/16 */;
}
.xtfl1 {
  position: relative;
  width: 750px /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 button {
  position: absolute;
  top: 0;
  right: -100px;
}
.xtfl1 h3 {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: 10px;
}
.expansion {
  position: absolute;
  top: 0;
  right: 120px;
}
.example {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
  font-size: 15px;
  color: #666666;
}
.example_img {
  margin-left: 1.875rem /* 30/16 */;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
}
.options {
  display: flex;
  width: 46.875rem /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.addLable {
  width: 12.5rem /* 200/16 */;
  height: 2.25rem /* 36/16 */;
}
.btn_addlable {
  width: 6rem /* 96/16 */;
  height: 2.125rem /* 34/16 */;
  margin-left: 1.5625rem /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 6.25rem /* 100/16 */;
}
.tishi {
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.lookPicture {
  width: 750px;
  height: 110px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding-top: 10px;
}
.addaudio {
  display: flex;
  width: 730px;
  height: 55px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 10px;
}
.replaceaudio {
  width: 100px /* 65/16 */;
  height: 42px;
  button {
    width: 100%;
    height: 100%;
    text-align: center;
  }
}
.update {
  position: absolute;
  display: flex;
  top: 0;
  right: 200px;
}
.insert_answer {
  position: absolute;
  bottom: 10px;
  right: 500px;
}
.upload-demo {
  margin-left: 30px;
}
</style>
